import type { ReactNode } from 'react';
import { Button, type ButtonVariant } from '@/components/ui/Button';
import { Dialog } from '@/components/ui/Dialog';

interface ConfirmDialogProps {
  title: string;
  children: ReactNode;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  cancelLabel?: string;
  confirmVariant?: ButtonVariant;
  cancelVariant?: ButtonVariant;
  dismissible?: boolean;
}

export function ConfirmDialog({
  title,
  children,
  confirmLabel,
  onConfirm,
  onCancel,
  cancelLabel = 'Cancel',
  confirmVariant = 'primary',
  cancelVariant = 'ghost',
  dismissible = true,
}: ConfirmDialogProps) {
  return (
    <Dialog
      title={title}
      onClose={onCancel}
      dismissible={dismissible}
      actions={(
        <>
          <Button type="button" variant={cancelVariant} onClick={onCancel}>{cancelLabel}</Button>
          <Button type="button" variant={confirmVariant} onClick={onConfirm}>{confirmLabel}</Button>
        </>
      )}
    >
      {children}
    </Dialog>
  );
}
